import {
  FormatBold,
  FormatItalic,
  FormatStrikethrough,
  FormatUnderlined,
  Image,
  Link,
  Looks3,
  LooksOne,
  LooksTwo,
  Subscript,
  Superscript,
  VisibilityOff,
} from '@styled-icons/material';
import {
  MARK_BOLD,
  MARK_ITALIC,
  MARK_STRIKETHROUGH,
  MARK_SUBSCRIPT,
  MARK_SUPERSCRIPT,
  MARK_UNDERLINE,
} from '@udecode/plate-basic-marks';
import { ELEMENT_H1, ELEMENT_H2, ELEMENT_H3 } from '@udecode/plate-heading';
import { LinkToolbarButton } from '@udecode/plate-ui-link';
import {
  BlockToolbarButton,
  MarkToolbarButton,
} from '@udecode/plate-ui-toolbar';
import { MobileTippy } from 'apps/exegesis/utils/components/MobileTippy';
import styled from 'styled-components';
import { CustomToolbarImage } from './plugins/CustomToolbarImage';
import { HIDE_MARK } from './plugins/Hide/Hide';
export const MainEditorToolbar = (props: { editorId: string }) => {
  return (
    <CustomHeadingToolbar>
      <BlockToolbarButton
        type={ELEMENT_H1}
        icon={
          <MobileTippy
            placement="bottom"
            content="header 1"
            arrow={false}
            offset={[0, 0]}
          >
            <LooksOne />
          </MobileTippy>
        }
      />

      <BlockToolbarButton
        type={ELEMENT_H2}
        icon={
          <MobileTippy
            placement="bottom"
            content="header 2"
            arrow={false}
            offset={[0, 0]}
          >
            <LooksTwo />
          </MobileTippy>
        }
      />
      <BlockToolbarButton
        type={ELEMENT_H3}
        icon={
          <MobileTippy
            placement="bottom"
            content="header 3"
            arrow={false}
            offset={[0, 0]}
          >
            <Looks3 />
          </MobileTippy>
        }
      />
      <MarkToolbarButton
        type={MARK_BOLD}
        icon={
          <MobileTippy
            placement="bottom"
            content="bold"
            arrow={false}
            offset={[0, 0]}
          >
            <FormatBold />
          </MobileTippy>
        }
      />
      <MarkToolbarButton
        type={MARK_ITALIC}
        icon={
          <MobileTippy
            placement="bottom"
            content="italic"
            arrow={false}
            offset={[0, 0]}
          >
            <FormatItalic />
          </MobileTippy>
        }
      />
      <MarkToolbarButton
        type={MARK_UNDERLINE}
        icon={
          <MobileTippy
            placement="bottom"
            content="underline"
            arrow={false}
            offset={[0, 0]}
          >
            <FormatUnderlined />
          </MobileTippy>
        }
      />
      <MarkToolbarButton
        type={HIDE_MARK}
        icon={
          <MobileTippy
            placement="bottom"
            content="hide"
            arrow={false}
            offset={[0, 0]}
          >
            <VisibilityOff />
          </MobileTippy>
        }
      />
      <MarkToolbarButton
        type={MARK_STRIKETHROUGH}
        icon={
          <MobileTippy
            placement="bottom"
            content="strikethrough"
            arrow={false}
            offset={[0, 0]}
          >
            <FormatStrikethrough />
          </MobileTippy>
        }
      />
      <MarkToolbarButton
        type={MARK_SUPERSCRIPT}
        icon={
          <MobileTippy
            placement="bottom"
            content="superscript"
            arrow={false}
            offset={[0, 0]}
          >
            <Superscript />
          </MobileTippy>
        }
      />
      <MarkToolbarButton
        type={MARK_SUBSCRIPT}
        icon={
          <MobileTippy
            placement="bottom"
            content="subscript"
            arrow={false}
            offset={[0, 0]}
          >
            <Subscript />
          </MobileTippy>
        }
      />
      <LinkToolbarButton
        icon={
          <MobileTippy
            placement="bottom"
            content="link"
            arrow={false}
            offset={[0, 0]}
          >
            <Link />
          </MobileTippy>
        }
      />
      <CustomToolbarImage
        editorId={props.editorId}
        icon={
          <MobileTippy
            placement="bottom"
            content="image"
            arrow={false}
            offset={[0, 0]}
          >
            <Image />
          </MobileTippy>
        }
      />
    </CustomHeadingToolbar>
  );
};

const CustomHeadingToolbar = styled.div`
  position: absolute;
  display: flex;
  /* align-items: center; */
  box-sizing: content-box;
  min-height: 40px;
  width: 75vw;
  color: rgb(68, 68, 68);
  padding: 15px 18px 17px;
  /* border-bottom: 2px solid rgb(238, 238, 238); */
  flex-wrap: wrap;
  user-select: none;

  padding-left: calc(40px + 0.5rem);
  padding-bottom: 0px;
  transition: opacity 0.5s;
  background-color: ${(props) => props.theme.backgroundColor || 'white'};
  z-index: 100;
  transform: translateX(-40px);

  & > .slate-ToolbarButton-active {
    color: ${(props) => props.theme.colors.link.text};
  }
`;
